import { Grid } from '@mui/material'
import { format, startOfToday } from 'date-fns'
import {
  createContext,
  useCallback,
  useEffect,
  useState,
  useMemo,
  useContext,
} from 'react'
import { useImmerReducer } from 'use-immer'
import Programa from '../../../components/Programa/Programa'
import { metodoPrograma } from '../../../components/api'
import { ConsultsList } from './components/schedule-calendar'
import { GlobalContext } from '../../../App'

const initialValues = {
  statics: {
    agendamentos: 0,
    preparacao: 0,
    confirmados: 0,
    aguardando: 0,
    atendido: 0,
    cancelado: 0,
    finalizado: 0,
  },
  consults: [],
  terapias: [],
  selectedDay: startOfToday(),
  agendamentoSelecionado: {
    modal: false,
    data: null,
  },
  medico: null,
}

const reducer = (state = initialValues, { type, field, value }) => {
  switch (type) {
    case 'setConsults':
      return { ...state, consults: value }
    case 'setTerapias':
      state.terapias = value
      return
    default:
      state[field] = value
  }
}
export const AgendaContext = createContext(initialValues)

const ProgramacaoAgendamentoCheckin = () => {
  const { localAtendimento } = useContext(GlobalContext)
  const [consultaAgenda, setConsultaAgenda] = useState({
    carregando: false,
    concluida: false,
  })

  const [state, dispatch] = useImmerReducer(reducer, initialValues)

  const contextValues = useMemo(
    () => ({ ...state, dispatch }),
    [state, dispatch],
  )

  const { selectedDay } = state

  const listaAgendamentos = useCallback(() => {
    if (localAtendimento !== undefined && localAtendimento?.[0] !== undefined) {
      setConsultaAgenda({ carregando: true, concluida: false })
      metodoPrograma(
        'lista',
        {
          data: format(selectedDay, 'yyyy-MM-dd'),
          idLocalAtendimento: localAtendimento?.[0],
        },
        'CtrlProgramacaoAgendaCheckin',
      )
        .then((res) => {
          if (res.status) {
            dispatch({ type: 'setConsults', value: res.lista })
            dispatch({ type: 'setTerapias', value: res.pacienteSemana })
            setConsultaAgenda({ carregando: false, concluida: true })
          } else {
            setConsultaAgenda({ carregando: false, concluida: false })
          }
        })
        .catch(() => {
          setConsultaAgenda({ carregando: false, concluida: false })
        })
    }
  }, [selectedDay, localAtendimento, dispatch])

  useEffect(() => {
    listaAgendamentos()
  }, [listaAgendamentos])

  useEffect(() => {
    let atualizacaoPendente

    const atualizaAgendaAoReceberMensagem = (event) => {
      let mensagem = event.detail

      if (typeof mensagem === 'string') {
        try {
          mensagem = JSON.parse(mensagem)
        } catch {
          return
        }
      }

      if (mensagem?.tipo !== 'AGENDAMENTO_ALTERADO') return

      const idLocalAtual = localAtendimento?.[0]
      if (
        mensagem.idLocalAtendimento !== undefined &&
        String(mensagem.idLocalAtendimento) !== String(idLocalAtual)
      ) {
        return
      }

      const dataVisualizada = format(selectedDay, 'yyyy-MM-dd')
      const datasAfetadas = [
        mensagem.data,
        mensagem.dataAnterior,
        mensagem.dataNova,
      ]
        .filter(Boolean)
        .map((data) => String(data).slice(0, 10))

      if (
        datasAfetadas.length > 0 &&
        !datasAfetadas.includes(dataVisualizada)
      ) {
        return
      }

      clearTimeout(atualizacaoPendente)
      atualizacaoPendente = setTimeout(listaAgendamentos, 250)
    }

    window.addEventListener(
      'frameworkfl:websocket-message',
      atualizaAgendaAoReceberMensagem,
    )

    return () => {
      clearTimeout(atualizacaoPendente)
      window.removeEventListener(
        'frameworkfl:websocket-message',
        atualizaAgendaAoReceberMensagem,
      )
    }
  }, [listaAgendamentos, localAtendimento, selectedDay])

  return (
    <AgendaContext.Provider value={contextValues}>
      <Programa codigo={'CtrlProgramacaoAgendaCheckin'}>
        <Grid container spacing={0}>
          <Grid item xs={12} sm={12}>
            <ConsultsList {...{ listaAgendamentos, consultaAgenda }} />
          </Grid>
        </Grid>
      </Programa>
    </AgendaContext.Provider>
  )
}

export default ProgramacaoAgendamentoCheckin
